import { z } from 'zod';
export const StructuredTagSchema = z.object({
    name: z.string(),
    level: z.enum([
        'positive',
        'moderate',
        'negative'
    ]),
    correlatesTo: z.string().nullish()
});
export const UnstructuredTagSchema = z.object({
    name: z.string(),
    level: z.string()
});
export const TagsSchema = z.object({
    structured: z.array(StructuredTagSchema).nullish(),
    unstructured: z.array(UnstructuredTagSchema).nullish()
}).meta({
    id: 'Tags'
});

//# sourceMappingURL=tags.schema.js.map